module.exports = { "default": require("core-js/library/fn/object/is-sealed"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/is-sealed.js
// module id = 775
// module chunks = 1